import { textColors } from "@/shared/forms/ColorPicker";
import { useCustomDrag } from "./CustomDragContext";

export default function PhaseBar({ span, onClick, rowStart }) {
  const { element: elementLeft, isDragging: isDraggingLeft } = useCustomDrag({
    date: span.data.startDate,
    item: { id: span.id + "_left", type: "phase_start", uuid: span.data.uuid },
  });
  const { element: elementRight, isDragging: isDraggingRight } = useCustomDrag({
    date: span.data.endDate,
    item: { id: span.id + "_right", type: "phase_end", uuid: span.data.uuid },
  });
  return (
    <div
      key={span.id}
      onClick={onClick}
      className={"hw_phase" + (span.isBegin ? " isBegin" : "") + (span.isEnd ? " isEnd" : "")}
      style={{
        backgroundColor: span.data.color,
        color: textColors[span.data.color],
        gridColumnStart: String(span.colStart),
        gridColumnEnd: String(span.colEnd + 1),
        gridRow: String(rowStart + span.row),
      }}
    >
      {span.isBegin ? <div className={"hw_phase_handle_start" + (isDraggingLeft ? " dragging" : "")} {...elementLeft} /> : null}
      <div className="hw_phase_name">
        <div className="hw_phase_namepart">{span.data.name}</div>
        <div className="hw_phase_comment">{span.data.comment}</div>
      </div>
      {span.isEnd ? <div className={"hw_phase_handle_end" + (isDraggingRight ? " dragging" : "")} {...elementRight} /> : null}
    </div>
  );
}
